export default "__VITE_ASSET__iNBb0GdF__"